import { render, staticRenderFns } from "./BarChart3.vue?vue&type=template&id=380e7eb0&"
import script from "./BarChart3.vue?vue&type=script&lang=js&"
export * from "./BarChart3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports